import { saleSelectors } from 'store/sale/selectors';
import { RootState } from 'store/store';
import { walletSelectors } from 'store/wallet/selectors';
import { Sale } from 'types/Sale';
import { SALE_MAP } from 'types/constants';

const { SUBSCRIPTION_STATUS_TYPES } = SALE_MAP;

const ActiveSubscriptionWithFailedPaymentTypes = [SUBSCRIPTION_STATUS_TYPES.ERROR] as const;

export const getActiveSubscriptionPaymentErrorType = (
  sale: Sale,
  wallet: RootState['wallet'],
  auth: RootState['auth']
): 'DECLINE' | 'MISSING_METHOD' | undefined => {
  const subscriptionStatus = saleSelectors.subscriptionStatus(sale);
  const isSubscriptionActive = saleSelectors.isSubscriptionActive(sale);
  const paymentInfo = saleSelectors.subscriptionPaymentInfo(sale);
  const userWallets = walletSelectors.userWallets(wallet);
  const entityId = auth?.entityId;

  if (!subscriptionStatus || !isSubscriptionActive) {
    return undefined;
  }

  const isSubscriptionStatusError = ActiveSubscriptionWithFailedPaymentTypes.includes(
    subscriptionStatus as typeof ActiveSubscriptionWithFailedPaymentTypes[number]
  );

  const isAllowedToModifySubscription =
    auth?.isUserSignedIn && isSubscriptionActive && paymentInfo?.walletInfo?.id === entityId;

  const isWalletNotFound =
    userWallets &&
    userWallets.findIndex((w) => saleSelectors.isWalletUsedForActiveSubscription(sale, w)) < 0;

  if (isSubscriptionStatusError) {
    return 'DECLINE';
  }

  if (isAllowedToModifySubscription && isWalletNotFound) {
    return 'MISSING_METHOD';
  }

  return undefined;
};
